import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

const ProjectRow = ({ project, isReversed, colors }) => {
  const cardVariants = {
    offscreen: {
      x: isReversed ? 100 : -100,
      opacity: 0
    },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.2,
        duration: 0.8
      }
    }
  };
  
  return (
    <motion.div
      className={`grid md:grid-cols-2 gap-10 md:gap-16 items-center`}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: 0.3 }}
    >
      <motion.div 
        className={`relative aspect-video rounded-2xl overflow-hidden shadow-2xl ${isReversed ? 'md:order-2' : ''}`} 
        variants={cardVariants}
      >
        <img
          src={project.image}
          alt={`${project.title} screenshot`}
          className="absolute w-full h-full object-cover object-top"
        />
        {/* Browser-like top bar */}
        <div className="absolute top-0 left-0 w-full h-8 bg-gray-800/80 backdrop-blur-sm flex items-center px-3 space-x-1.5">
          <div className="w-3 h-3 rounded-full bg-red-500"></div>
          <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
          <div className="w-3 h-3 rounded-full bg-green-500"></div>
        </div>
      </motion.div>
      
      <motion.div className="text-left" variants={cardVariants}>
        <span className="text-sm font-bold text-indigo-400">{project.type}</span>
        <h3 className="syne-font text-4xl md:text-5xl font-bold mt-2 mb-6">{project.title}</h3>
        <p className="text-white/70 leading-relaxed mb-8">{project.description}</p>
        
        <div className="flex flex-wrap gap-3 mb-8">
            {project.features.map(feature => (
                <span key={feature} className="bg-white/10 text-white/80 text-sm font-medium px-4 py-2 rounded-full">
                    {feature}
                </span>
            ))}
        </div>

        <a 
          href={project.domain.startsWith('http') ? project.domain : `https://${project.domain}`} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="inline-flex items-center gap-2 syne-font text-lg font-bold text-black bg-white px-8 py-4 rounded-full shadow-lg transition-transform hover:scale-105"
        >
          Visit Website <ArrowUpRight />
        </a>
      </motion.div>
    </motion.div>
  );
};

export default ProjectRow;